// extracted by mini-css-extract-plugin
export default {"cls1":"CoreXNav-cls1__de76d7155b92fc93d7d4","cls2":"CoreXNav-cls2___858c0a985adeb84b148 CoreXNav-cls1__de76d7155b92fc93d7d4"};